// extracted by mini-css-extract-plugin
module.exports = {"container":"_searchbar_container__2BVMd","toggle":"_searchbar_toggle__-iHGa","searchbar":"_searchbar_searchbar__2s5Ac"};